import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { DataIdArrayConverterFactory, DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Cahier } from '../../habilitation/models/cahier.model';
import { Operateur } from '../../intervenant/models/operateur.model';
import { College } from './college.model';
import { StatutJure } from './statut-jure.model';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class JureCdc {
    static jsonMap = {
        id: { key: 'id', optional: true },
        nom: { key: 'nom', optional: true },
        telFixe: { key: 'telFixe', optional: true, default: '' },
        telPortable: { key: 'telPortable', optional: true, default: '' },
        colleges: { key: 'idCollege', converter: new (DataIdArrayConverterFactory.build(College, 'colleges'))() },
        cahiers: { key: 'idCahiers', converter: new (DataIdArrayConverterFactory.build(Cahier, 'cahiers'))() },
        idsOperateurs: { key: 'idIntervenantList', converter: new (ArrayClassConverterFactory.build(Number))() },
        raisonSocialesOperateurs: { key: 'raisonSocialeIntervenantList', converter: new (ArrayClassConverterFactory.build(String))() },
        dateDerniereFormation: { key: 'dateDerniereFormation', converter: new DateConverter(), optional: true },
        mail: { key: 'mail', optional: true, default: '' },
        statutJure: { key: 'idStatut', converter: new (DataIdConverterFactory.build(StatutJure, 'statutsJure'))(), optional: true },
        dateCommission: { key: 'dateCommission', converter: new DateConverter(), optional: true },
        numeroCommission: { key: 'numeroCommission', optional: true, default: '' }
    };

    id: number;
    nom: string;
    telFixe: string;
    telPortable: string;
    colleges: College[];
    cahiers: Cahier[];
    idsOperateurs: number[];
    raisonSocialesOperateurs: string[];
    dateDerniereFormation: moment.Moment;
    mail: string;
    statutJure: StatutJure;
    dateCommission: moment.Moment;
    numeroCommission: string;

    operateurs: Operateur[];
    checked?: boolean;
}
